<a (click)="changeSortOrder()" role="button" tabindex="0" class="link sort-btn">
    <mat-icon *ngIf="descOrder === false">keyboard_arrow_down</mat-icon>
    <mat-icon *ngIf="descOrder === true">expand_less</mat-icon>
    <mat-icon *ngIf="descOrder === undefined">horizontal_rule</mat-icon>
</a>
